export const CALCULATOR_SPONSOR_COMPANY_NAME = 'Реклама ООО МФК «Мани Мен» ИНН: 7704784072';
export const CALCULATOR_SPONSOR_URL = 'https://goto.startracking.ru/api/v1/redirect?offer_id=100509&aff_id=2&erid=2W5zFHw5F5b';
export const CALCULATOR_SPONSOR_PIXEL_VIEW =
  'https://goto.startracking.ru/api/v1/impression?offer_id=100509&aff_id=2&erid=2W5zFHw5F5b';

export const CALCULATOR_SPONSOR_TITLE = 'Оценивайте свои финансовые возможности и риски';

export const CALCULATOR_SPONSOR_PROMO_DOCUMENT_LINK = 'https://adengi.ru/docs/Terms-of-free-first-loan.pdf';

export const CALCULATOR_SPONSOR_TOKEN = '2W5zFHw5F5b';
